import script from "./BaseHeaderTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeaderTop.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeaderTop.vue?vue&type=style&index=0&id=75c99e4a&lang=scss"

const __exports__ = script;

export default __exports__